var _excluded = ["components", "mixins", "palette", "shadows", "shape", "sizing", "spacing", "transitions", "typography"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createTheme as createMuiTheme } from '@mui/material/styles';
import { merge } from 'lodash';
import tokens from '@mineral/tokens/build/light/index.json';
import { createComponents } from './createComponents';
import { mixins } from './createMixins';
import { createSizing } from './createSizing';
import { createPalette } from './createPalette';
import { shape } from './createShape';
import { typography } from './createTypography';
export var createTheme = function createTheme(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      componentsInput = _options.components,
      mixinsInput = _options.mixins,
      paletteInput = _options.palette,
      shadowsInput = _options.shadows,
      shapeInput = _options.shape,
      sizingInput = _options.sizing,
      spacingInput = _options.spacing,
      transitionsInput = _options.transitions,
      typographyInput = _options.typography,
      restOptions = _objectWithoutPropertiesLoose(_options, _excluded);

  var mineralPalette = createPalette(paletteInput == null ? void 0 : paletteInput.mode);

  var _createMuiTheme = createMuiTheme({
    spacing: spacingInput || tokens.spacing
  }),
      spacing = _createMuiTheme.spacing;

  var theme = createMuiTheme(_extends({
    mixins: merge({}, mixins, mixinsInput),
    palette: merge({}, mineralPalette, paletteInput),
    shadows: merge([], Object.values(tokens.shadow), shadowsInput),
    shape: merge({}, shape, shapeInput),
    sizing: merge({}, createSizing(spacing), sizingInput),
    spacing: spacing,
    transitions: transitionsInput,
    typography: merge({}, typography, typographyInput)
  }, restOptions));
  return createMuiTheme(_extends({}, theme, {
    components: merge({}, createComponents(theme), componentsInput)
  }));
};